var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconDoorFrameMaterial = function SvgIconDoorFrameMaterial(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1335 -778)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd"
    },
    d: "M11,8a1,1,0,0,1,1-1H28a1,1,0,0,1,1,1V32a1,1,0,0,1-1,1H12a1,1,0,0,1-1-1ZM27,31H26V11.414l1-1ZM24.586,10H15.413l-1-1H25.586ZM14,11.415h0l-1-1V31h1ZM24,31H16V12h8v8H22a1,1,0,0,0,0,2h2Z",
    transform: "translate(1335 778)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDoorFrameMaterial, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-door-frame-material.56089059.svg";
export { ForwardRef as ReactComponent };